<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="card p-3 border-radius-xl bg-white">
          <div class="card-header">
            <h5 class="font-weight-bolder mb-0mb-0">{{ $t("Edifici")}}</h5>
            <div class="button-row d-flex">
              <router-link :to="{name:'Edificio', params:{id: 0}}" class="ms-auto">
                <argon-button
                    type="button"
                    color="dark"
                    variant="gradient"
                >{{$t('Nuovo')}}</argon-button>
              </router-link>
            </div>
          </div>
          <div class="card-body">
            <edifici-data-table :key="edificiKey" :edifici="edifici"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EdificiDataTable from "@/parts/DataTables/EdificiDataTable.vue";
import ArgonButton from "@/components/ArgonButton.vue";

export default {
  name: "Edifici",
  components: {ArgonButton, EdificiDataTable},
  data() {
    return {
      edifici: [],
      edificiKey: Math.random()
    };
  },
  mounted() {
    this.apiClient.getEdifici().then(response => {
      if(response.data){
        this.edifici = response.data;
        this.edificiKey = Math.random();
      }
    });
  },
};
</script>
